import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  return (
    <main className="about">
      <header className="about__intro">
        <div className="about__intro-heading">
          <p className="about__kicker">
            <span>OUR STORY</span>
            <span>DESIGNED IN HONG KONG</span>
          </p>
          <h1>{siteConfig.tagline}</h1>
        </div>

        <div className="about__intro-copy">
          <p>{siteConfig.description}</p>
          <p>
            {siteConfig.wordmark} treats the desk as a personal space—not just a
            place to work or play. Every release begins with a point of view and
            ends as a tool built to be used every day.
          </p>
        </div>
      </header>

      <figure className="about__studio">
        <picture>
          <source
            media="(max-width: 640px)"
            srcSet="/img/story-studio-mobile.webp"
          />
          <source srcSet="/img/story-studio.webp" type="image/webp" />
          <img
            src="/img/story-studio.webp"
            alt="A blue and white keyboard in a carefully lit creative studio"
            fetchPriority="high"
          />
        </picture>
        <figcaption>
          <span>THE DESK, REFRAMED</span>
          <span>01 / THE STUDIO</span>
        </figcaption>
      </figure>

      <section className="about__statement" aria-label="Our point of view">
        <p>BUILT FOR PERFORMANCE.</p>
        <p>DESIGNED FOR SELF-EXPRESSION.</p>
      </section>

      <section className="about__chapter">
        <div className="about__chapter-copy">
          <span className="about__chapter-number">01</span>
          <p className="about__kicker">DESIGN IN CAPSULES</p>
          <h2>ONE IDEA,<br />FULLY EXPRESSED.</h2>
          <p>
            Each capsule starts with a visual world—color, texture, typography,
            and atmosphere—then carries it through keyboards and the objects
            around them. The result is a setup that feels collected, not
            assembled.
          </p>
        </div>
        <div className="about__chapter-media">
          <div className="about__chapter-collage">
            <img src="/img/product-02.webp" alt="A blue and white keyboard" loading="lazy" />
            <img src="/img/product-05.webp" alt="A translucent ice-blue keyboard" loading="lazy" />
            <img src="/img/product-13.webp" alt="A navy keyboard with warm accent keys" loading="lazy" />
          </div>
          <span>COLOR / FORM / STORY</span>
        </div>
      </section>

      <section className="about__chapter about__chapter--reverse">
        <div className="about__chapter-copy">
          <span className="about__chapter-number">02</span>
          <p className="about__kicker">MORE THAN A KEYBOARD</p>
          <h2>THE WHOLE SETUP<br />IS THE CANVAS.</h2>
          <p>
            Performance matters in every click, glide, and keystroke. We pair
            considered engineering with a clear graphic language, creating gear
            that earns its place on the desk long after the first impression.
          </p>
        </div>
        <div className="about__chapter-media about__chapter-media--dark">
          <div className="about__chapter-collage about__chapter-collage--accessories">
            <img src="/img/product-17.webp" alt="An ultralight black and orange mouse" loading="lazy" />
            <img src="/img/product-23.webp" alt="A coiled green keyboard cable" loading="lazy" />
            <img src="/img/product-22.webp" alt="A set of translucent artisan keycaps" loading="lazy" />
          </div>
          <span>DETAIL / FEEL / FUNCTION</span>
        </div>
      </section>

      <section className="about__manifesto">
        <p className="about__kicker">THE NEXT LEVEL IS PERSONAL</p>
        <blockquote>
          “THE BEST SETUP IS THE ONE THAT COULD ONLY BELONG TO YOU.”
        </blockquote>
        <p>
          That belief guides {siteConfig.brandName}: limited stories, expressive
          hardware, and no separation between how a product performs and how it
          makes a space feel.
        </p>
      </section>

      <section className="about__cta">
        <div>
          <p className="about__kicker">FIND YOUR CENTERPIECE</p>
          <h2>MAKE THE DESK<br />YOUR OWN.</h2>
        </div>
        <Link className="site-button site-button--light" to="/shop">
          EXPLORE THE COLLECTION <FiArrowUpRight aria-hidden="true" />
        </Link>
      </section>
    </main>
  );
}

export default About;
